import React, { PureComponent } from 'react';
import './index.scss'
import {Toast} from 'antd-mobile';
import { getVerifycode, reg, regWithChannel } from '@/services/api';
import _ from 'lodash';
import { grantCouponByLogged } from '@/components/CrgtEvent';
class RegForm extends PureComponent{
  state = {
    mobile: '',
    verifyCode: '',
    timeCount: 0,
    loading: true
  }

  async componentDidMount() {
    const {loggedCondition, condition, routerSuccess, handleChangePage, routerFail} = this.props
    console.log('loggedCondition',loggedCondition)
    if (!_.isEmpty(loggedCondition) && loggedCondition === 'yes') {
      const res = await grantCouponByLogged();
      if (res.code === 0 && _.has(res, 'data')) {
        if(_.has(res.data, 'prizes')) {
          if(_.isEmpty(condition) || (!_.isEmpty(condition) && condition==='all') || (!_.isEmpty(condition)&& condition !=='all'&& _.get(res.data, condition))){
            handleChangePage && handleChangePage(routerSuccess, res.data)
          }else {
            handleChangePage && handleChangePage(routerFail,res.data)
          }
        } else {
          return;
        }
      }
    }
  }

  countDown = () => {
    const task = setInterval(() => {
      const { timeCount } = this.state;
      if (timeCount === 0) {
        clearInterval(task);
      } else {
        this.setState({
          timeCount: timeCount - 1,
        });
      }
    }, 1000);

  }

  getCode = async () => {
    const { timeCount, mobile } = this.state;
    if (!(/^1[3456789]\d{9}$/.test(mobile))) {
      Toast.fail('手机号格式错误', 1);
      return false;
    }
    if (timeCount === 0) {
      this.setState({
        timeCount: 60,
      }, this.countDown);
      const res = await getVerifycode({ mobile });
      if (res.code === 0) {
        Toast.success('验证码已发送', 1);
      }
    }
  }

  submit = async () => {
    const { mobile, verifyCode } = this.state;
    const {regCondition, condition, routerSuccess, handleChangePage, routerFail} = this.props
    if (!(/^1[3456789]\d{9}$/.test(mobile))) {
      Toast.fail('手机号格式错误', 1);
      return false;
    }
    if (verifyCode.length === 0) {
      Toast.fail('请输入验证码', 1);
      return false;
    }
    let res={};
    if(!_.isEmpty(regCondition) && regCondition === 'yes'){
     res = await regWithChannel({
       login: {
        mobile,
        verifyCode,
       } 
      });
    } else{
      res = await reg({
        login: {
          mobile,
          verifyCode,
         } 
      });
    }
    
    if (res.code === 0) {
      window._ACCESSTOKEN_ = res.data.token;
      if(_.isEmpty(condition) || (!_.isEmpty(condition) && condition==='all') || (!_.isEmpty(condition)&& condition !=='all'&& _.get(res.data, condition))){
        handleChangePage && handleChangePage(routerSuccess, res.data)
      }else {
        handleChangePage && handleChangePage(routerFail,res.data)
      }
    }
  }

  render(){
    const { mobile, verifyCode, timeCount  } = this.state;
    const {
    background,
    titleBg,
    labelColor,
    input1Label,
    input2Label,
    inputBgColor,
    vcodeBgColor,
    input1Tip,
    input2Tip,
    vcodeColor,
    inputColor, buttonBgColor,buttonColor,style} = this.props;
    return(
      <div className="login-form" style={{...style,background:background,}}>
      <div className="login-form-title" style={{backgroundImage: `url(${titleBg})`}}/>
      <div className="form-item">
        <div className="label" style={{color:labelColor}}>{input1Label}</div>
        <input maxLength="11" style={{background:inputBgColor, color:inputColor}}
          placeholder={input1Tip}
          value={mobile}
          onChange={(e) => { this.setState({ mobile: e.target.value }); }}
        />
      </div>
      <div className="form-item">
        <div className="label" style={{color:labelColor}}>{input2Label}</div>
        <input maxLength="6" style={{background:inputBgColor, color:inputColor}}
          className="has-btn"
          placeholder={input2Tip}
          value={verifyCode}
          onChange={(e) => { this.setState({ verifyCode: e.target.value }); }}
        />
        <button
          className="time"
          style={{background:vcodeBgColor, color:vcodeColor}}
          type="button"
          onClick={this.getCode}
        >
          {timeCount === 0 ? '获取验证码' : `${timeCount}s`}
        </button>
      </div>
      <button
        className="submit"
        style={{background: buttonBgColor, color: buttonColor}}
        type="button"
        onClick={this.submit}
      >
        立即领取
      </button>
    </div>
    )
  }
    
}

export default RegForm;